import "lightgallery.js";
import "lg-thumbnail.js";
import "lg-video.js";
import "./lightgallery.scss";

export default {};
